module.exports = __webpack_public_path__ + "img/clients1-1023.ec03975.png";